module.exports = __webpack_public_path__ + "static/media/traycorp7.35248b6a.png";